import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { INGREDIENTS } from '../data/mock';
import Formula from './home/Formula';
import Reveal from '../components/Reveal';
import ProductBox from '../components/ProductBox';
import { useFlavour } from '../context/FlavourContext';

export default function Ingredients() {
  const navigate = useNavigate();
  const { flavour } = useFlavour();
  return (
    <div className="pt-24">
      <section className="py-16 md:py-20">
        <div className="max-w-[1400px] mx-auto px-5 grid lg:grid-cols-2 gap-10 items-center">
          <Reveal>
            <p className="font-cond tracking-[0.3em] text-white/40 mb-3">SCIENCE. NATURE. PERFORMANCE.</p>
            <h1 className="font-display text-5xl md:text-7xl">THE FORMULA<br /><span className="text-flavour flavour-transition">BEHIND S-MAN</span></h1>
            <p className="text-white/60 mt-5 max-w-md">9 active ingredients. One formula. Carefully selected ingredients, combined in a modern chewable format for men who want to feel their best, every day.</p>
          </Reveal>
          <Reveal delay={150} className="flex justify-center"><ProductBox flavourId={flavour.id} size="lg" /></Reveal>
        </div>
      </section>

      <Formula />

      {/* full formula table */}
      <section className="py-16 bg-[#080808]">
        <div className="max-w-3xl mx-auto px-5">
          <Reveal className="mb-8"><h2 className="font-display text-3xl md:text-5xl">NO MYSTERY.<br /><span className="text-flavour flavour-transition">THE FULL FORMULA.</span></h2><p className="text-white/50 mt-3">The exact formula per 2 chewable tablets (daily serving).</p></Reveal>
          <div className="rounded-2xl border border-white/10 overflow-hidden">
            {INGREDIENTS.map((ing, i) => (
              <div key={ing.id} className={`flex items-center justify-between px-5 py-3.5 ${i%2?'bg-white/[0.02]':''}`}>
                <span className="font-cond tracking-wide text-white/80">{ing.name}</span>
                <span className="font-cond" style={{color:flavour.primary}}>{ing.amount}</span>
              </div>
            ))}
          </div>
          <p className="text-xs text-white/30 mt-4">Food supplement. Not a substitute for a varied and balanced diet. Follow recommended daily dose. Values are placeholders and editable via CMS.</p>
        </div>
      </section>

      <section className="py-20 text-center">
        <div className="flex flex-col sm:flex-row gap-4 items-center justify-center">
          <button onClick={()=>navigate('/flavours')} className="inline-flex items-center gap-2 px-8 py-4 rounded-lg bg-[#ff2d2d] text-white font-cond tracking-wide text-lg hover:brightness-110 transition-all">CHOOSE YOUR FLAVOUR <ArrowRight className="w-5 h-5" /></button>
          <button onClick={()=>navigate('/flavours')} className="inline-flex items-center gap-2 px-8 py-4 rounded-lg border border-white/20 font-cond tracking-wide text-lg hover:bg-white/5 transition-all">OR TRY THE MIX BOX <ArrowRight className="w-5 h-5" /></button>
        </div>
      </section>
    </div>
  );
}
